import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
    selector: 'supportInfoModal',
    templateUrl: './support-info-modal.component.html',
    styleUrls: ['./support-info-modal.component.less']
})
export class SupportInfoModalComponent {
    @ViewChild('supportInfoModal') modal: ModalDirective;

    show(): void {
        this.modal.show();
    }

    close(): void {
        this.modal.hide();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/support-info-modal.component.ts